
export enum CG_OCU_METRICS_DIMENSIONS {
    AWS_ACCOUNT_ID = 'AwsAccountId',
    COLLECTION_GROUP_NAME = "CollectionGroupName",
    COLLECTION_GROUP_ID = "CollectionGroupId",
}

export interface GraphDefinition {
    title: string;
    paramSets: Array<{
        stats: string[];
        metricNames: string[];
        unit?: string;
        isRootAccount?: boolean;
    }>;
    mathFunctionParams?: Array<{
        id?: string;
        expression: string;
        label: string;
    }>;
}

export interface MetricDefinitions {
    namespace: string;
    dimensionNames: any;
    graphs: GraphDefinition[];
}

export interface MetricDefinitions {
    namespace: string;
    dimensionNames: any;
    graphs: GraphDefinition[];
}

export const OCU_METRICS_GRAPH = [
    {
        title: 'Search OCU History',
        paramSets: [
            {
                stats: ['Maximum'],
                metricNames: ['CxMetricsSearchOCU'],
                unit: 'Count',
            },
        ],
    },
    {
        title: 'Indexing OCU History',
        paramSets: [
            {
                stats: ['Maximum'],
                metricNames: ['CxMetricsIndexingOCU'],
                unit: 'Count',
            },
        ],
    },
];

export const CG_OCU_METRICS: MetricDefinitions = {
    namespace: 'AOSSBeholder/KAM/CxMetrics',
    dimensionNames: CG_OCU_METRICS_DIMENSIONS,
    graphs: OCU_METRICS_GRAPH,
};